module.exports = __webpack_public_path__ + "img/organization-5.7dc8f826.jpg";